import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/teams/')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/' });
  },
});
